import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "markdownText";

const keys = addTranslations(RESOURCE_NAME, {
    link_tooltip: {
        en: "This link will redirect you to an external website.",
        fr: "Ce lien vous redirigera vers un site web externe.",
    },
    copy_success: {
        en: "Text copied to clipboard",
        fr: "Texte copié dans le presse-papiers",
    },
});

export function useMarkdownTextTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
